<template>
  <div class="toggle-barriers">
    <div class="toggle-barriers__actions">
      <v-spacer />
      <v-btn
        color="success"
        outlined
        class="text-none toggle-barriers__btn"
        rounded
        @click="confirmAction('unblock')"
      >
        <v-icon left small>mdi-lock-open-outline</v-icon>
        Включить ГРЗ
      </v-btn>
      <v-btn
        color="error"
        outlined
        class="text-none toggle-barriers__btn"
        rounded
        @click="confirmAction('block')"
      >
        <v-icon left small>mdi-lock-outline</v-icon>
        Выключить ГРЗ
      </v-btn>
    </div>

    <v-dialog v-model="dialog" max-width="440" content-class="dialog-border-radius" persistent>
      <v-card class="toggle-barriers-dialog">
        <div class="toggle-barriers-dialog__header">
          <h3 class="toggle-barriers-dialog__title">
            <v-icon left :color="action === 'unblock' ? 'success' : 'error'">
              {{ action === 'unblock' ? 'mdi-lock-open-outline' : 'mdi-lock-outline' }}
            </v-icon>
            Подтверждение действия
          </h3>
          <v-btn icon small text @click="dialog = false" aria-label="Закрыть">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text class="toggle-barriers-dialog__body">
          <template v-if="action === 'unblock'">
            Подтверждая, вы <strong class="toggle-barriers-dialog__highlight toggle-barriers-dialog__highlight--success">включите</strong> открытие по ГРЗ шлагбаумов ЖК?
          </template>
          <template v-else>
            Подтверждая, вы <strong class="toggle-barriers-dialog__highlight toggle-barriers-dialog__highlight--error">выключите</strong> открытие по ГРЗ шлагбаумов ЖК?
          </template>
        </v-card-text>
        <v-card-actions class="toggle-barriers-dialog__actions">
          <v-spacer />
          <v-btn
            color="primary"
            outlined
            class="text-none"
            rounded
            @click="dialog = false"
          >
            <v-icon left small>mdi-close</v-icon>
            Отмена
          </v-btn>
          <v-btn
            :color="action === 'unblock' ? 'success' : 'error'"
            class="text-none"
            dark
            rounded
            @click="performAction"
          >
            <v-icon left small>mdi-check</v-icon>
            Да
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="resultDialog" max-width="560" content-class="dialog-border-radius" persistent>
      <v-card class="toggle-barriers-dialog">
        <div class="toggle-barriers-dialog__header">
          <h3 class="toggle-barriers-dialog__title">
            <v-icon left :color="action === 'unblock' ? 'success' : 'error'">
              {{ action === 'unblock' ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline' }}
            </v-icon>
            Результат {{ action === 'unblock' ? 'включения' : 'выключения' }} открытия по ГРЗ шлагбаумов
          </h3>
          <v-btn icon small text @click="resultDialog = false" aria-label="Закрыть">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text class="toggle-barriers-dialog__body toggle-barriers-dialog__body--list">
          <div class="toggle-barriers-dialog__result-list">
            <div
              v-for="(result, index) in results"
              :key="index"
              class="toggle-barriers-dialog__result-item"
            >
              <span class="toggle-barriers-dialog__result-address">{{ result.id }}, {{ result.address }}</span>
              <v-chip
                :color="result.success ? 'success' : 'error'"
                small
                outlined
                class="toggle-barriers-dialog__result-chip"
              >
                {{ result.success ? 'Успешно' : 'Ошибка' }}
              </v-chip>
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="toggle-barriers-dialog__actions">
          <v-spacer />
          <v-btn
            color="primary"
            class="text-none"
            dark
            rounded
            @click="resultDialog = false"
          >
            <v-icon left small>mdi-close</v-icon>
            Закрыть
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'BaseToggleStatusBarriers',
  props: {
    barriers: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      dialog: false,
      action: '',
      resultDialog: false,
      results: [],
    };
  },
  methods: {
    ...mapActions({
      unlockBarrier: 'Barriers/unlockBarrier',
      blockBarrier: 'Barriers/blockBarrier',
    }),
    confirmAction (action) {
      this.action = action;
      this.dialog = true;
    },
    performAction () {
      this.dialog = false;
      if (this.action === 'unblock') {
        this.unlockingDevice();
      } else if (this.action === 'block') {
        this.blockingDevice();
      }
    },
    blockingDevice () {
      this.results = [];
      const promises = this.barriers.map(barrier => {
        return this.blockBarrier(barrier.id)
          .then(() => {
            this.results.push({ id: barrier.id, address: barrier.address, success: true });
          })
          .catch(() => {
            this.results.push({ id: barrier.id, address: barrier.address, success: false });
          });
      });
      Promise.all(promises)
        .then(() => {
          this.$flash_success('Все шлагбаумы ЖК обработаны!');
        })
        .catch(() => {
          this.$flash_warning('Некоторые шлагбаумы не были обработаны.');
        })
        .finally(() => {
          this.resultDialog = true;
          this.$emit('getResidentComplex');
        });
    },
    unlockingDevice () {
      this.results = [];
      const promises = this.barriers.map(barrier => {
        return this.unlockBarrier(barrier.id)
          .then(() => {
            this.results.push({ id: barrier.id, address: barrier.address, success: true });
          })
          .catch(() => {
            this.results.push({ id: barrier.id, address: barrier.address, success: false });
          });
      });
      Promise.all(promises)
        .then(() => {
          this.$flash_success('Все шлагбаумы ЖК обработаны!');
        })
        .catch(() => {
          this.$flash_warning('Некоторые шлагбаумы не были обработаны.');
        })
        .finally(() => {
          this.resultDialog = true;
          this.$emit('getResidentComplex');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.toggle-barriers__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding: 12px 0;
}

.toggle-barriers__btn {
  text-transform: none;
  font-weight: 500;
}

.toggle-barriers-dialog {
  border-radius: 12px;
  overflow: hidden;
}

.toggle-barriers-dialog__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  background: #f5f7f8;
}

.toggle-barriers-dialog__title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #37474f;
  margin: 0;
  display: flex;
  align-items: center;
}

.toggle-barriers-dialog__body {
  padding: 20px;
  font-size: 0.9375rem;
  color: #546e7a;
  line-height: 1.5;
}

.toggle-barriers-dialog__highlight--success {
  color: #388e3c;
}

.toggle-barriers-dialog__highlight--error {
  color: #d32f2f;
}

.toggle-barriers-dialog__body--list {
  padding-top: 12px;
}

.toggle-barriers-dialog__result-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 320px;
  overflow-y: auto;
}

.toggle-barriers-dialog__result-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  background: #fafafa;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.toggle-barriers-dialog__result-address {
  font-size: 0.9375rem;
  color: #37474f;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.toggle-barriers-dialog__result-chip {
  flex-shrink: 0;
}

.toggle-barriers-dialog__actions {
  padding: 12px 20px 20px;
  gap: 12px;
}

@media screen and (max-width: 600px) {
  .toggle-barriers__actions {
    flex-direction: column;
    align-items: stretch;
  }
  .toggle-barriers__btn {
    margin: 0;
  }
}
</style>
